export const ACTIONS_SHIFT = {
  INVALIDATE: 'SHIFTS_INVALIDATE',
  RECEIVE: 'SHIFTS_RECEIVE',
  DELETE: 'SHIFT_DELETE',
  UPDATE: 'SHIFT_UPDATE',
};

const shiftConstants = {};

export default shiftConstants;
